// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { CustomerInformation } from '../Classes/CustomerInformation';
import { SystemBasedLaborSettings } from '../Classes/SystemBasedLaborSettings';
import { ProposalSettings } from '../Classes/ProposalSettings';
import { SiteInformation } from '../Classes/SiteInformation';
import { TaxSettingsModel } from '../Classes/TaxSettingsModel';
import { TaxRateCollection } from '../Classes/TaxRateCollection';
import { PricePresentationData } from '../Classes/PricePresentationData';
import { EstimateGrossMargin } from '../Classes/EstimateGrossMargin';
import { EstimateSellPrice } from '../Classes/EstimateSellPrice';
import { PriceRecommendationsModel } from '../Classes/PriceRecommendationsModel';
import { TTS_Details } from '../Classes/TTS_Details';
import { TTS_Submittal_Details } from '../Classes/TTS_Submittal_Details';
import { ProjectEpartsLists } from '../Classes/ProjectEpartsLists';
export class OtherMetaData {
  customerInformation: CustomerInformation;
  systemBasedLaborSettings: SystemBasedLaborSettings;
  proposalSettings: ProposalSettings;
  siteInformation: SiteInformation;
  taxSettings: TaxSettingsModel;
  taxRateCollection: TaxRateCollection;
  pricePresentationData: PricePresentationData;
  grossMargin: EstimateGrossMargin;
  sellPrice: EstimateSellPrice;
  priceRecommendations: PriceRecommendationsModel;
  shipToAccount: CustomerInformation;
  billToAccount: CustomerInformation;
  endUserAccount: CustomerInformation;
  ttsDetails: TTS_Details;
  ttsSubmittalDetails: TTS_Submittal_Details;
  projectEPartsList: ProjectEpartsLists;
}
